import { Component } from 'react';
import 'redux';
import PropTypes from 'prop-types';

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Sale... Remove this comment to see the full error message
import IndexPage from 'SalesContentIndexUI/components/IndexPage';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../u... Remove this comment to see the full error message
import { assertPropsDefined } from '../utils/PropValidationUtils';
import { getLocationQuery } from 'SalesContentIndexUI/data/utils/router';
import { stringify } from 'hub-http/helpers/params';
import { jsx as _jsx } from "react/jsx-runtime";
export default class IndexContainer extends Component {
  constructor(...args) {
    super(...args);
    this.updateHistoryWithQuery = updatedQuery => {
      const {
        rootPath,
        location
      } = this.props;
      const query = getLocationQuery(location);
      this.props.history.push({
        pathname: rootPath,
        search: stringify(Object.assign({}, query, updatedQuery))
      });
    };
  }
  componentDidMount() {
    if (this.props.onMount) {
      this.props.onMount();
    }
  }
  render() {
    const {
      location,
      rootPath,
      title
    } = this.props;
    assertPropsDefined({
      location,
      rootPath,
      title
    });
    return /*#__PURE__*/_jsx(IndexPage, Object.assign({}, this.props));
  }
}
IndexContainer.propTypes = {
  children: PropTypes.any,
  defaultTab: PropTypes.string,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  onMount: PropTypes.func,
  rootPath: PropTypes.string.isRequired,
  tabs: PropTypes.object,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  pageLayout: PropTypes.string
};
IndexContainer.defaultProps = {
  rootPath: '/'
};